import { Injectable } from '@angular/core';
import { EventSummary, LiveFieldEvent, MeetList, TeamList } from '@athleticnet/athletic-live-api-models';
import { BehaviorSubject, catchError, combineLatest, map, Observable, of, Subscription } from 'rxjs';
import { MeetEventSummary } from '@athleticnet/athletic-live-api-models';
import { EventFilterModel } from '../models/event-filter.model';
import { LiveRunEvent } from '@athleticnet/athletic-live-api-models';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IsSidebarOpenService {
  sidebarOpen = true;

  private _isSidebarOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isSidebarOpen: Observable<boolean> = this._isSidebarOpen.asObservable();

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this._isSidebarOpen.next(this.sidebarOpen);
  }

  closeSidebar() {
    this.sidebarOpen = false;
    this._isSidebarOpen.next(this.sidebarOpen);
  }

  openSidebar() {
    this.sidebarOpen = true;
    this._isSidebarOpen.next(this.sidebarOpen);
  }
}
